// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hNpS","requiredAsterisk":"Info_requiredAsterisk__3hKdJ"};